module.exports = __webpack_public_path__ + "static/media/jb-kayttaa-refraktromeetteria.2aa956d8.mp4";


/*****************
 ** WEBPACK FOOTER
 ** ./media/videos/jb-kayttaa-refraktromeetteria.mp4
 ** module id = 453
 ** module chunks = 0
 **/